import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { environment } from '../../../environments/environment';

declare var Intercom: any;
declare let window: any;

@Component({
  selector: 'app-agents-home',
  templateUrl: './agents.component.html',
  styleUrls: ['./agents.component.scss']
})
export class AgentsComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {}

  toLogin() {
    this.router.navigate(['/auth/login']);
  }

  toContact() {
    console.log('toContact');
    window.sa_event('contact_us', { page: 'agents' });
    Intercom('showNewMessage');
  }

  toDemo() {
    console.log('toDemo');
    window.sa_event('book_demo', { page: 'agents' });
    window.open(environment.bookDemoUrl, '_blank');
  }
}
